import * as ReactSelect from "react-select";
import AsyncSelect from "react-select/async";
import Loader from "../../util/Loader";
import { baseUrl } from "../../store/airport/apis";
const { components } = ReactSelect;
// Example function to simulate fetching data from an API
const fetchUsers = async (inputValue: any) => {
  if (inputValue && inputValue.length > 1) {
    const response = await fetch(
      `${baseUrl}/flights/airlines?q=${inputValue}`
    );
    const data = await response.json();
    return data;
  }
};

const BasicAirlineSearchInput = ({
  name,
  onChange,
  placeholder,
  value,
  pos = "left",
  variant = "light",
}: any) => {
  const dark = variant === "dark";
  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      backgroundColor: dark ? "transparent" : "#fff",
      border: "none",
      minHeight: "32px",
      borderColor: "none !important",
      outline: "none !important",
      boxShadow: "none", // Disables the box-shadow on focus
      "&:hover": { borderColor: "gray" }, // Optional: style for hover
      "&:focus": { outline: "none" },
    }),
    valueContainer: (base: any) => ({
      ...base,
      height: "32px",
      padding: "0 0px",
      borderColor: "none !important",
      outline: "none !important",
    }),
    input: (base: any) => ({
      ...base,
      margin: "0px",
      padding: "0px",
      height: "32px",
      fontSize: "14px",
      color: dark ? "#fff" : base.color,
      borderColor: "transaparent",
      /* "&:hover": {
      borderColor: state.isFocused ? "#aaa" : base.borderColor,
    }, */
      outline: "none !important",
    }),
    singleValue: (base: any) => ({
      ...base,
      color: dark ? "#fff" : base.color,
    }),
    multiValue: (base: any) => ({
      ...base,
      backgroundColor: dark ? "rgba(255,255,255,0.18)" : base.backgroundColor,
    }),
    multiValueLabel: (base: any) => ({
      ...base,
      color: dark ? "#fff" : base.color,
    }),
    indicatorsContainer: (base: any) => ({
      ...base,
      height: "32px",
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      color: state.isSelected ? "#ffffff" : "#302D63",
      backgroundColor: state.isSelected ? "#302D63" : "#ffffff",
      padding: "5px 10px",
      margin: "0",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    indicator: () => ({
      display: "none",
    }),
    placeholder: (base: any) => ({
      ...base,
      color: dark ? "rgba(255,255,255,0.4)" : "#17171720",
      fontSize: "1rem",
      lineHeight: "2rem",
      fontWeight: "800",
    }),

    menu: (provided: any) => {
      let x = {
        ...provided,
        backgroundColor: "#ffff",
        borderRadius: "8px",
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.15)",
        padding: 0,
        zIndex: 2000,
        width: 350,
      };
      if (pos === "left") {
        x = { ...x, left: 0 };
      } else if (pos === "right") {
        x = { ...x, right: 0 };
      }
      return x;
    },
    container: (base: any) => ({
      ...base,
      width: "100%",
      height: "32px",
    }),
  };

  const loadOptions = (inputValue: any) => {
    return fetchUsers(inputValue);
  };
  const CustomOption = (props: any) => {
    return (
      <components.Option {...props}>
        <div className=" font-semibold  capitalize cursor-pointer hover:bg-slate-100 ">
          <div className="flex items-center space-x-4">
            <div className="text-lg">
              <img width={30} src={props.data.logoUrl} />
            </div>
            <div className="text-sm ">
              <div className="p-0 m-0">
                {props.data.name}
                <span>{` (${props.data.code})`}</span>
              </div>
              <p className="text-[10px] font-light capitalize p-0 m-0">{` ${props.data.countryName}`}</p>
            </div>
          </div>
        </div>
      </components.Option>
    );
  };

  const CustomLoader = (props: any) => {
    return (
      <components.LoadingIndicator {...props}>
        <Loader />
      </components.LoadingIndicator>
    );
  };
  const CustomNoOptionsMessage = (props: any) => (
    <components.NoOptionsMessage {...props}>
      {/* Custom message or JSX can go here */}
      <span style={{ fontStyle: "italic", color: "#999" }}>
        No results found. Try another search!
      </span>
    </components.NoOptionsMessage>
  );
  return (
    <div
      className={
        dark
          ? "border-white/25 bg-white/10 outline-none flex flex-col border-[1px] py-1 h-14 rounded-[14px] w-full text-white px-3 focus-within:border-orange-400 transition-colors"
          : "border-[#302D6340] bg-white  outline-none flex flex-col border-[1px] py-1 h-14 rounded-[4px] w-full text-[#171717] px-3  focus:border-b-[#EE723A] focus:border-2"
      }
    >
      <label className={dark ? "text-xs text-white/55" : "text-xs text-slate-500"}>{name}</label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadOptions}
        defaultOptions
        components={{
          Option: CustomOption,
          LoadingIndicator: CustomLoader,
          DropdownIndicator: () => null,
          NoOptionsMessage: CustomNoOptionsMessage,
        }}
        placeholder={placeholder}
        styles={customStyles}
        onChange={onChange}
        menuPlacement="top"
        menuPortalTarget={document.body}
        value={value}
        getOptionLabel={(option: any) => option.name}
        getOptionValue={(option: any) => option}
        isClearable
        isMulti
        menuPosition="absolute"
      />
    </div>
  );
};

export default BasicAirlineSearchInput;
